/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import ListItemLink from '../../../../../components/Common/ListItemLink/ListItemLink';
import MyBalanceHistory from './MyBalanceHistory';
import MyBalancePay from './MyBalancePay';
import MyBalancePayOut from './MyBalancePayOut';
import BalancesBlocks from '../../../../../components/UserFlowFunds/BalancesBlocks';

class MyBalance extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="panel panel-default">
          <div className="panel-bar bg-main">
            <div className="hor-scroll hor-scroll_xs">
              <ul className="nav nav-tabs nav-tabs-lg hor-scroll-wrapper">
                <ListItemLink to={'/main/my-balance/history'}>
                  {t('История')}
                </ListItemLink>
                <ListItemLink to={'/main/my-balance/pay'}>
                  {t('Пополнить счет')}
                </ListItemLink>
                <ListItemLink to={'/main/my-balance/payout'}>
                  {t('Вывод средств')}
                </ListItemLink>
              </ul>
            </div>
          </div>
        </div>

        <BalancesBlocks />

        <Switch>
          <Route
            exact
            path="/main/my-balance"
            render={() => <Redirect from="/" to="/main/my-balance/history" />}
          />
          <Route
            path="/main/my-balance/history"
            render={() => (
              <MyBalanceHistory
                setGroupQueryParamsAndUpdateHistory={
                  this.props.setGroupQueryParamsAndUpdateHistory
                }
              />
            )}
          />
          <Route
            path="/main/my-balance/pay"
            render={() => (
              <div>
                <MyBalancePay />
              </div>
            )}
          />
          <Route
            path="/main/my-balance/payout"
            render={() => (
              <div>
                <MyBalancePayOut
                  setGroupQueryParamsAndUpdateHistory={
                    this.props.setGroupQueryParamsAndUpdateHistory
                  }
                />
              </div>
            )}
          />
        </Switch>
      </React.Fragment>
    );
  }
}

MyBalance.propTypes = {
  // IN
  setGroupQueryParamsAndUpdateHistory: PropTypes.func.isRequired
};

export default withRouter(MyBalance);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyBalance/MyBalance.js